import { render, staticRenderFns } from "./SwitchContent.vue?vue&type=template&id=1e542fb2"
import script from "./SwitchContent.vue?vue&type=script&lang=js"
export * from "./SwitchContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports